export const API_BASE_URL =
  'https://legacy.techblog.demo.youcefdeveloper.com/wp-json/blog/v1'

export const API_HOST = 'legacy.techblog.demo.youcefdeveloper.com'

export const PER_PAGE = 5
